import { Box, Stack, Typography } from '@mui/material';
import { Campaign } from 'domains/campaigns/types';
import { themeColors } from 'colors';

type WinnerFailedStatusProps = {
    campaign: Campaign;
};

const WinnerFailedStatus = ({ campaign }: WinnerFailedStatusProps) => {
    const winnerSend = campaign.sends?.find((send) => send.id === campaign.abTestConfig?.winnerSendId);
    const winnerName = winnerSend?.name || 'Winner';

    return (
        <Box
            sx={{
                backgroundColor: themeColors.error.background,
                borderRadius: '8px',
                padding: '16px',
                paddingLeft: '24px',
            }}
        >
            <Stack spacing={0.5}>
                <Stack direction="row" alignItems="baseline" spacing={1.4}>
                    <Box
                        sx={{
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor: themeColors.error.main,
                        }}
                    />
                    <Typography>winner failed</Typography>
                </Stack>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    Failed to send '{winnerName}' to remaining contacts
                </Typography>
            </Stack>
        </Box>
    );
};

export default WinnerFailedStatus;
